<div class="documents-page">
  @if (form) {
    <div class="row-with-title" *let="isDocumentCreating$ | async as creating">
      <div class="col-title">
        {{ 'menu.myDocuments' | transloco }}
      </div>

      <div
        class="col-add-button"
        *let="
          isCreatingDocumentOperationsAreInProgress$
            | async as creatingDocumentOperationsAreInProgress
        "
      >
        @if (canWrite$ | async) {
          <app-button
            class="after-control"
            icon="add"
            [type]="btnTypes.Flat"
            label="{{ 'buttons.addDocument' | transloco }}"
            (onClick)="addDocument()"
            [size]="btnSizes.Basic"
            [disabled]="!!creating || !(canWriteFileUpload$ | async)"
          ></app-button>
          <app-button
            class="after-control"
            [type]="btnTypes.Flat"
            label="{{ 'buttons.createDocument' | transloco }}"
            (onClick)="createDocument()"
            [size]="btnSizes.Basic"
            [disabled]="!!creatingDocumentOperationsAreInProgress || !(canWriteDocumentGeneration$ | async)"
          ></app-button>
        }
      </div>
    </div>

    @if ((canWrite$ | async) || (canDelete$ | async)) {
      <div
        [ngClass]="{ 'visible-flex': isAnySelected && filteredDocumentsCount }"
        class="row-adaptive operations-btns edit-fieldset"
      >
        <span class="edit-fieldset-legend">{{ 'labels.editFieldsetLegend' | transloco }}</span>

        @if (canWrite$ | async) {
        <div class="col-adaptive operation-btn-col">
          <app-button
            [icon]="'stacks'"
            [type]="btnTypes.Icon_Stroked"
            [size]="btnSizes.InOperationRow"
            [label]="'buttons.editDocType' | transloco"
            (onClick)="bulkEditDocType()"
          ></app-button>
        </div>
        <div class="col-adaptive operation-btn-col">
          <app-button
            [icon]="'view_cozy'"
            [type]="btnTypes.Icon_Stroked"
            [size]="btnSizes.InOperationRow"
            [label]="'buttons.editCounterparties' | transloco"
            (onClick)="bulkEditDocCounterparties()"
          ></app-button>
        </div>
        <div class="col-adaptive operation-btn-col">
          <app-button
            [icon]="'compare_arrows'"
            [type]="btnTypes.Icon_Stroked"
            [size]="btnSizes.InOperationRow"
            [label]="'buttons.editPosition' | transloco"
            (onClick)="bulkEditDocPosition()"
          ></app-button>
        </div>
        <div class="col-adaptive operation-btn-col">
          <app-button
            [icon]="'clock_loader_20'"
            [type]="btnTypes.Icon_Stroked"
            [size]="btnSizes.InOperationRow"
            [label]="'buttons.editStatus' | transloco"
            (onClick)="bulkEditDocStatus()"
          ></app-button>
        </div>
        <div class="col-adaptive operation-btn-col">
          <app-button
            [icon]="'globe'"
            [type]="btnTypes.Icon_Stroked"
            [size]="btnSizes.InOperationRow"
            [label]="'buttons.editLanguage' | transloco"
            (onClick)="bulkEditDocLanguage()"
          ></app-button>
        </div>
        }
        @if (canDelete$ | async) {
        <div class="col-adaptive operation-btn-col">
          <app-button
            [icon]="'delete'"
            [type]="btnTypes.Icon_Stroked"
            [size]="btnSizes.InOperationRow"
            [label]="'buttons.delete' | transloco"
            (onClick)="bulkDelete()"
          ></app-button>
        </div>
        }
      </div>
    }

    <div [ngClass]="{ hidden: isAnySelected }" [formGroup]="form">
      <div class="row-adaptive filters">
        <div class="col-adaptive main-filter-col">
          <app-search-input
            placeholder="{{ 'placeholders.filterByDocName' | transloco }}"
            formControlName="documentName"
            class="filter-control"
          ></app-search-input>
        </div>
        <div class="col-adaptive">
          <app-tui-multi-select-autocomplete
            formControlName="documentType"
            [autocompleteOptions]="docTypeItems"
            [placeholderKey]="'placeholders.filterByTypeOfDoc'"
          ></app-tui-multi-select-autocomplete>
        </div>
        <div class="col-adaptive">
          <app-tui-multi-select-autocomplete
            formControlName="counterparty"
            [autocompleteOptions]="partyItems"
            [placeholderKey]="'placeholders.filterByCounterparty'"
          ></app-tui-multi-select-autocomplete>
        </div>
        <div class="col-adaptive">
          <app-tui-multi-select-autocomplete
            formControlName="position"
            [autocompleteOptions]="positionItems"
            [placeholderKey]="'placeholders.filterByMyPosition'"
          ></app-tui-multi-select-autocomplete>
        </div>
        <div class="col-adaptive">
          <app-tui-multi-select-autocomplete
            formControlName="status"
            [autocompleteOptions]="docStatusItems"
            [placeholderKey]="'placeholders.filterByStatus'"
          ></app-tui-multi-select-autocomplete>
        </div>
        <div class="col-adaptive">
          <app-tui-multi-select-autocomplete
            formControlName="languageId"
            [autocompleteOptions]="contentLanguages"
            optionLabel="displayName"
            [placeholderKey]="'placeholders.filterByLanguage'"
          ></app-tui-multi-select-autocomplete>
        </div>
        <div class="col-adaptive filter-btn-col">
          <app-button
            icon="close"
            [type]="btnTypes.Icon_Stroked"
            [size]="btnSizes.InFilterRow"
            [label]="'buttons.clearFilters' | transloco"
            (onClick)="clearFilters()"
          ></app-button>
        </div>
      </div>
    </div>

    <div
      [ngClass]="{ 'visible-flex': isAnySelected && filteredDocumentsCount }"
      class="row-adaptive selections-btns"
    >
      <div class="col-adaptive operation-btn-col">
        <span class="selected-items-count-info">
          <span class="text">
            <b>{{ selectedDocumentsCount }}</b> {{ textCountOfSelectedDocs | transloco }}
          </span>
        </span>
      </div>
      <div class="col-adaptive operation-btn-col" *ngIf="filteredDocumentsCount > 1">
        <app-button
          [type]="btnTypes.Link"
          [size]="btnSizes.InOperationRow"
          [label]="textButtonsSelectAllDocs | transloco: { count: filteredDocumentsCount }"
          (onClick)="selectAll()"
        ></app-button>
      </div>
      <div class="col-adaptive operation-btn-col">
        <app-button
          [type]="btnTypes.Link"
          [size]="btnSizes.InOperationRow"
          [label]="'buttons.unselectAll' | transloco"
          (onClick)="resetSelections()"
        ></app-button>
      </div>
    </div>
  }

  @if (dataRecieved && form) {
    <div class="documents-page__grid-region">
      <app-documents-list
        class="app-documents-table"
        [activeDocumentDetailsId]="activeDocumentDetails?.uniqueId || null"
      ></app-documents-list>
    </div>
  }

  @if (activeDocumentDetails) {
    <button
      class="documents-page__content-overlay"
      type="button"
      aria-label="Close drawer"
      (click)="closeDetailsDrawer()"
    ></button>
  }

  <app-document-details-drawer
    [isOpen]="!!activeDocumentDetails"
    [detailsTrigger]="activeDocumentDetails"
    (closed)="closeDetailsDrawer()"
  ></app-document-details-drawer>
</div>
